import { UseFetchReturn } from '@vueuse/core';
import { useFetchInstance } from './useFetchInstance';

export function useCategory() {
    async function getProductsGroupByCategories(): Promise<UseFetchReturn<CategoryApi[]>> {
        return await useFetchInstance('/products?groupedByCategory=true&published=true').get().json();
    }

    return {
        getProductsGroupByCategories
    };
}
